import currentSession from './currentSession';
import App from '../app';
import {TeamJobs} from '../model/Team';
import {useEffect} from 'preact/hooks';
import {AnyCommand} from '../type';
import {CommandContainer} from '../../../framework/type';
import {useLoadTemplatesCommand} from '../command/loadTemplates';

export default function currentTeamTemplates(): [TeamJobs, CommandContainer<AnyCommand>] {
  const {teamId} = currentSession();
  const [command, getTemplates] = useLoadTemplatesCommand();

  const id = teamId.id;

  useEffect(() => {
    if (!id) return;
    getTemplates({teamId: id});
  }, [id]);

  const state = App.useQuery(state => {
    const team = state.team.get(id);

    if (!team) return TeamJobs.EMPTY;

    return team.templates;
  }, [id]);

  return [state, command];
}